import { render } from "./VideoModal.vue?vue&type=template&id=94e5e00a&ts=true"
import script from "./VideoModal.vue?vue&type=script&lang=ts"
export * from "./VideoModal.vue?vue&type=script&lang=ts"

import "./VideoModal.vue?vue&type=style&index=0&id=94e5e00a&lang=scss"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__